import {
  Badge,
  Columns,
  FoldPanel,
  Note,
  Readout,
  ReadoutGroup,
  SettingsSteps,
  Spinner,
  Specimens,
  Stack,
  Typography,
} from '@src/components';

/** Badges, notes and the spinner: the small pieces that report state. */
export function StatusSection() {
  return (
    <FoldPanel
      id="status"
      title="Status"
      hint="A badge labels a thing, a note explains a section, a spinner says the page is waiting. None of them take a click."
      example={`<Badge tone="success">Card opened</Badge>

<Note tone="warning">Anyone with this link can take a name.</Note>

<Spinner size="medium" label="Loading" />`}
    >
      <Specimens
        label="Badge tones"
        note="Neutral, success and warning sit on a surface. Info is the card's blue ink only — a filled chip on a white page is a blob."
      >
        <Badge>Quick draw</Badge>
        <Badge tone="info">Invitation not sent</Badge>
        <Badge tone="success">Card opened</Badge>
        <Badge tone="warning">Link issued</Badge>
      </Specimens>

      <Specimens
        label="Notes"
        note="Section-level explanation. Distinct from Hint, which belongs to one field and speaks as an alert."
      >
        <Stack gap={4} wide>
          <Note tone="success">
            <Typography as="p" role="body/sm" color="inherit">
              The draw is done. Now hand out the results — there are three ways.
            </Typography>
          </Note>
          <Note tone="info">A personal link opens one card and nobody else&apos;s.</Note>
          <Note tone="warning">
            Anyone holding the shared link can take any name that is still free.
          </Note>
          <Note tone="neutral" icon={null}>
            Without an icon, for a quiet aside.
          </Note>
        </Stack>
      </Specimens>

      <Specimens
        label="Settings steps"
        note="Guest convert walkthrough — three in a row on desktop, lavender border, support number disc."
      >
        <SettingsSteps
          steps={[
            'Open the profile switcher in the top right corner.',
            'Click “Add account” and sign in however you prefer.',
            'Return to the switcher and link the guest profile.',
          ]}
          testId="ui-kit-settings-steps"
        />
      </Specimens>

      <Specimens label="Spinner" note="The label is for screen readers; nothing is drawn for it.">
        <Spinner size="small" label="Loading" />
        <Spinner size="medium" label="Loading" />
      </Specimens>

      <Specimens
        label="Readouts"
        note="A value to take away rather than change. Codes are centred and never wrap; a link breaks wherever it has to."
      >
        <Stack gap={4} wide>
          <ReadoutGroup label="Card link">
            <Readout>santa-secret.ru/box/9XLUCb/card/A32C7F1E</Readout>
          </ReadoutGroup>
          <ReadoutGroup label="Recovery codes">
            <Columns columns={2} gap={2}>
              <Readout align="center">5BDD-9108-1811</Readout>
              <Readout align="center">D556-0292-848F</Readout>
              <Readout align="center">47D2-13CC-1191</Readout>
              <Readout align="center">80DF-40AF-3750</Readout>
            </Columns>
          </ReadoutGroup>
        </Stack>
      </Specimens>
    </FoldPanel>
  );
}
